<template>


  <div class="container">
    <div class="handle-box-search">

      <el-row class="head-search">
        <el-col :span="8">
          <span class="title">大于单数:</span>
          
          <el-input v-model="search_data.num" class="handle-input mr10"
            @keyup.enter.native="searchorderNumLists"></el-input>
        </el-col>




      </el-row>





      <el-button type="primary" icon="el-icon-search" @click="searchorderNumLists">搜索</el-button>
      <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>




    </div>
    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="handleSelectionChange">





      <el-table-column prop="name" label="客户名称" min-width="150">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>客户唯一编码: {{ scope.row.consumer_code }}</p>
            <div slot="reference">
              <el-tag size="medium" style="border:0;background-color:#FFF;color:#333">{{ scope.row.name }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column prop="phone" label="手机电话" min-width="150">
      </el-table-column>



      <el-table-column prop="num" label="单数" min-width="150">
      </el-table-column>


      <el-table-column label="用户级别">
        <template slot-scope="scope">
          <el-tag :type="scope.row.level == '普通用户' ? '' : 'success' ">
            {{ scope.row.level }}
          </el-tag>
        </template>
      </el-table-column>


    </el-table>


    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>


  </div>


</template>

<script>
  var _this;
  import bus from '@/components/common/bus';
  export default {
    components: {

    },
    data() {
      return {
        // 乘客名称
        consumer_name: '',
        consumer_phone: '',

        // 添加用户信息组件开关
        add_isShow: false,

        // 修改用户信息组件开关
        edit_isShow: false,

        // 用户钱包组件开关
        userWallet_isShow: false,

        // 用户账单组件开关
        userRecord_isShow: false,

        // 传入子组件的数据
        consumer_code_children: '',

        //详细搜索
        more_search: false,



        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          num: '',
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          }
        },
      };
    },
    created() {

      _this = this;

      // _this.orderNumLists();

      // 接收子组件传来的事件并初始化列表
      bus.$on('onSubmit', msg => {
        _this.orderNumLists();
      });

    },

    methods: {

      searchorderNumLists() {
        _this.search_data.page = 1;
        _this.orderNumLists();
      },
      // 搜索用户管理列表
      orderNumLists() {
        _this.$post(
            "/statistics/consumerOrderNumLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;


          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {
        console.log(_this.search_data);

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.orderNumLists();

      },
      handleSelectionChange(val) {

        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].driver_code);

        }
        _this.delDriverSubmit_data.driver_code_array = datalist;
      },


      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },

      // 解绑设备
      untying(code) {

        _this.$post(
          "/driver/untyingDriverMobileSubmit", {
            driver_code: code
          }
        ).then(res => {

          _this.$message.success('解绑设备成功');

        }).catch((err) => {

        })

      }
    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-dropdown {
    vertical-align: top;
  }

  .el-dropdown+.el-dropdown {
    margin-left: 15px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>